const SettingsGetter = {
    settings: state => state.settings,
    securityQuestions: state => state.securityQuestions
};

export default SettingsGetter;